module.exports = __webpack_public_path__ + "images/icons/psp-car-storage-guide/10x30-car.svg";